import { gql } from '@apollo/client';

export * from './softwareEscrowEnableReports.mutation.generated';

export const SOFTWARE_ESCROW_ENABLE_REPORTS = gql`
  mutation softwareEscrowEnableReports($softwareEscrowId: ID!) {
    softwareEscrowEnableReports(input: { softwareEscrowId: $softwareEscrowId }) {
      success
      errors
      softwareEscrow {
        id
        reportsEnabled
      }
    }
  }
`;
